import {DataARLedgerModel} from '../../../models/accountsReceivable/data-ar-ledger.model';
import {DataARLedgerListModel} from './data-ar-ledger-list.model';

export class DataArLedgerCredits {
  AmountPatient: number = 0;
  AmountInsurance: number = 0;
  Amount: number = 0;
  PatientID: string;
  enumARLedgerItemOriginType: string;
  enumARLedgerItemType: string;
  ledgerItems: DataARLedgerListModel[] = [];
}
